import * as React from 'react'

import classNames from 'classnames'

import { styles } from './index.styles'
import './index.styles.css'

export type Size = 'small' | 'medium' | 'big' | 'full'
interface Props {
  size?: Size
}

const ScrollableList = (props: React.PropsWithChildren<Props>) => {
  const { children, size = 'small' } = props

  return <div className={classNames('ScrollableList_scrollableList', styles[size])}>{children}</div>
}

export default ScrollableList
